<template>
	<div>
		<h5>Contrats</h5>
	</div>
</template>

<script>
export default {
	data () {
		return {
			
		}
	}
}
</script>

<style>

</style>